export default __webpack_public_path__ + "static/media/SFG-Data-GlyGen-Nov-2019.c55ea636.pdf";